import { render, staticRenderFns } from "./LiveTableSolo.vue?vue&type=template&id=55027cd3&scoped=true&"
import script from "./LiveTableSolo.vue?vue&type=script&lang=js&"
export * from "./LiveTableSolo.vue?vue&type=script&lang=js&"
import style0 from "./LiveTableSolo.vue?vue&type=style&index=0&id=55027cd3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55027cd3",
  null
  
)

export default component.exports